// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SGYLYVF9hzSXRHvIWUNV {
    padding: 2rem;
}

.JttpUN_ig6v_Kt4Z9Ypq,
.clO5ymNkmKCKKdwoLSrI {
    width: 60%;
}

.JttpUN_ig6v_Kt4Z9Ypq {
    padding-bottom: 2rem;
}

.clO5ymNkmKCKKdwoLSrI {
    display: grid;
    grid-template:  'a b' auto
                    'c c' auto / 1fr 1fr;
    gap: 2rem;
}

._Eb4ZuaVlaoZtN5ZWD73 {
    color: rgba(0, 0, 0, 0.85);
    font-family: Inter, sans-serif;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 1.61769rem */
}

.aVfmtv4ym3QXJifRVF8Q {
    color: rgba(0, 0, 0, 0.75);
    font-family: Inter, sans-serif;
    font-size: 0.85rem;
    font-style: normal;
    font-weight: 400;
    margin-bottom: 0.5rem;
    line-height: 150%; /* 1.21325rem */
}

@media screen and (max-width: 768px) {
    .clO5ymNkmKCKKdwoLSrI,
    .JttpUN_ig6v_Kt4Z9Ypq {
        width: 100%;
    }

    .clO5ymNkmKCKKdwoLSrI {
        grid-template:  'a' auto
                        'b' auto
                        'c' auto / 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/WhyInvest/WhyInvest.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb;wCACoC;IACpC,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,eAAe;AACtC;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB,EAAE,eAAe;AACtC;;AAEA;IACI;;QAEI,WAAW;IACf;;IAEA;QACI;;sCAE8B;IAClC;AACJ","sourcesContent":[".container {\n    padding: 2rem;\n}\n\n.headline,\n.grid {\n    width: 60%;\n}\n\n.headline {\n    padding-bottom: 2rem;\n}\n\n.grid {\n    display: grid;\n    grid-template:  'a b' auto\n                    'c c' auto / 1fr 1fr;\n    gap: 2rem;\n}\n\n.title {\n    color: rgba(0, 0, 0, 0.85);\n    font-family: Inter, sans-serif;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%; /* 1.61769rem */\n}\n\n.description {\n    color: rgba(0, 0, 0, 0.75);\n    font-family: Inter, sans-serif;\n    font-size: 0.85rem;\n    font-style: normal;\n    font-weight: 400;\n    margin-bottom: 0.5rem;\n    line-height: 150%; /* 1.21325rem */\n}\n\n@media screen and (max-width: 768px) {\n    .grid,\n    .headline {\n        width: 100%;\n    }\n\n    .grid {\n        grid-template:  'a' auto\n                        'b' auto\n                        'c' auto / 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SGYLYVF9hzSXRHvIWUNV`,
	"headline": `JttpUN_ig6v_Kt4Z9Ypq`,
	"grid": `clO5ymNkmKCKKdwoLSrI`,
	"title": `_Eb4ZuaVlaoZtN5ZWD73`,
	"description": `aVfmtv4ym3QXJifRVF8Q`
};
export default ___CSS_LOADER_EXPORT___;
